module.exports = __webpack_public_path__ + "img/style_7_pl.a3b1ab17.jpeg";